import { render, staticRenderFns } from "./ExchangeContractTypeSelect.vue?vue&type=template&id=070ea4f0&scoped=true&"
import script from "./ExchangeContractTypeSelect.vue?vue&type=script&lang=js&"
export * from "./ExchangeContractTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ea4f0",
  null
  
)

export default component.exports